import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { EstimationTable } from "./EstimationTable";

import { usePiping } from "../../PipingContext";

export function EstimationTab() {
  const [selectedRevision, setSelectedRevision] = useState(0);
  const { estimationTable, setEstimationTable } = usePiping();
  const revisions = Object.keys(estimationTable);
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current && Object.keys(estimationTable).length > 0) {
      initialized.current = true;
      setSelectedRevision(Object.keys(estimationTable).at(-1));
    }
  }, [estimationTable]);

  function handleAddRev(e) {
    const value = e.target.value;

    if (value === "__new") {
      const nextRev = String(
        Math.max(...Object.keys(estimationTable).map(Number)) + 1,
      );

      setEstimationTable((prev) => ({
        ...prev,
        [nextRev]: JSON.parse(JSON.stringify(prev[selectedRevision] || {})),
      }));

      setSelectedRevision(nextRev);
    } else {
      setSelectedRevision(value);
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 1,
        gap: 2,
      }}
    >
      <Box display="flex" alignItems="center" gap={4} justifyContent="center">
        <FormControl size="small">
          <InputLabel>Revision</InputLabel>
          <Select
            value={selectedRevision}
            onChange={handleAddRev}
            label="Revision"
            sx={{ minWidth: 140 }}
          >
            {revisions.map((rev) => (
              <MenuItem value={rev} key={rev}>
                {rev}
              </MenuItem>
            ))}
            <MenuItem value="__new" sx={{ fontStyle: "italic", color: "gray" }}>
              + Add New Revision
            </MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box>
        <EstimationTable revision={selectedRevision} />
      </Box>
    </Box>
  );
}
